<template>
<v-container class="container-terms">
    <v-row>
        <v-col cols="12" sm="12">
    <div>
        <p>
            <strong>EDURACLE PRIVACY POLICY</strong>
        </p>
		<p dir="ltr">
    		<strong>LAST REVISION: 18-Sep-2026</strong>
		</p>
        <p>
            This Privacy Policy describes how your personal information is
            collected, used, and shared when you visit or make a purchase from
            Eduracle.com or its sub-domains. Eduracle.com is a website which
            collects user data and provides services for preparation of
            competitive exams. (the “Website”). Sofos Learning Solutions Private
            Limited, A company incorporated under Companies Act is the operator
            of the Website- Eduracle.com ("Hereinafter Referred to as Sofos")
            and having its registered office at Cabin No. 23, 2nd Floor, West
            Block, Amanora Mall, Mundhwa–Kharadi Road, Amanora Park Town, Pune,
            Maharashtra – 411028.
        </p>
        <p>
            Eduracle.com recognizes the importance of maintaining your privacy.
            We value your privacy and appreciate your trust in us. This Policy
            describes how we treat user information we collect on
            <a target="_blank" href="https://www.eduracle.com">https://www.eduracle.com</a> and its subdomains. This Privacy Policy
            applies to current and former visitors to our website and to our
            online customers. By visiting and/or using our website, you agree to
            this Privacy Policy.
        </p>
        <p>
            PERSONAL INFORMATION WE COLLECT
        </p>
        <ul>
            <li dir="ltr">
                When initially creating a account, the following information may
                be collected and stored:
            </li>
        </ul>
        <ul>
            <li dir="ltr">
                The individuals first and last name
            </li>
            <li dir="ltr">
                The individuals e-mail address
            </li>
            <li dir="ltr">
                The individuals contact details like mobile number, address
            </li>
            <li dir="ltr">
                The individual’s enrollment as a student or teacher or anything
                else
            </li>
            <li dir="ltr">
                Such other information as may be required for providing
                effective services
            </li>
        </ul>
        <p>
            If a USER chooses not to provide this information, access to the
            LIMITED SERVICES offered by SOFOS will still be permitted. The
            information noted above is not required. Personal data collected by
            SOFOS is exclusively hosted and stored in India.
        </p>
        <ul>
            <li dir="ltr">
                When you visit the Website, we automatically collect certain
                information about your device, including information about your
                web browser, IP address, time zone, and some of the cookies that
                are installed on your device. Additionally, as you browse the
                Website, we collect information about the individual web pages
                or products that you view, what websites or search terms
                referred you to the Website, and information about how you
                interact with the Website. We refer to this automatically
                collected information as “Device Information.”
            </li>
        </ul>
        <p>
            We collect Device Information using the following technologies:
        </p>
        <p>
            “Cookies” are data files that are placed on your device or computer
            and often include an anonymous unique identifier. For more
            information about cookies, and how to disable cookies, visit
            <a target="_blank" href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a>.
        </p>
        <p>
            “Log files” track actions occurring on the Website, and collect data
            including your IP address, browser type, Internet service provider,
            referring/exit pages, and date/time stamps.
        </p>
        <p>
            “Web beacons,” “tags,” and “pixels” are electronic files used to
            record information about how you browse the Site.
        </p>
        <ul>
            <li dir="ltr">
                Additionally, when you make a purchase or attempt to make a
                purchase through the Website, we collect certain information
                from you, including your billing name, billing address and
                payment method when you buy a service. We NEVER collect your
                credit card number or credit card expiry date or other details
                pertaining to your credit card on our website. Credit card
                information will be obtained and processed by our online payment
                partner. We refer to this information as “Order Information.”
            </li>
            <li dir="ltr">
                Sub-Domains to Educational Institutes: The website provides
                sub-domains to education institutes whereby the institute uses
                website’s Online Testing and Analytics platform for the benefit
                of its students. While using the Online Testing and Analytics
                platform the institute gives access to personal data of students
                like their name, address and contact details and Sofos is
                authorized to use such data for marketing its services to the
                students.
            </li>
        </ul>
        <p>
            When we talk about “Personal Information” in this Privacy Policy, we
            are talking about Personal details, Device Information and Order
            Information as mentioned hereinabove.
        </p>
        <p>
            HOW DO WE USE YOUR PERSONAL INFORMATION?
        </p>
        <p>
            <strong>We use information to contact you: </strong>
            We might use the information you provide to contact you for
            confirmation of a purchase on our website or for other promotional
            purposes.
        </p>
        <p>
            <strong>We use information to fulfill your orders: </strong>
            We use the Personal Information that we collect generally to fulfill
            any orders placed through the Website (including processing your
            payment information, arranging for shipping, and providing you with
            invoices and/or order confirmations).
        </p>
        <p>
            <strong>
                We use information to respond to your requests or questions.
            </strong>
            We might use your information to confirm your registration for an
            event or contest.
        </p>
        <p>
            <strong
                >We use information to improve our products and
                services.</strong
            >
            We might use your information to customize your experience with us.
            This could include displaying content based upon your preferences.
        </p>
        <p>
            <strong>
                We use information to look at site trends and customer
                interests.
            </strong>
            We may use your information to make our website and products better.
            We may combine information we get from you with information about
            you we get from third parties. (for example, by generating analytics
            about how our customers browse and interact with the Website, and to
            assess the success of our marketing and advertising campaigns)
        </p>
        <p>
            <strong>We use information for security purposes.</strong>
            We may use information to protect our company, our customers, or our
            websites.
        </p>
        <p>
            <strong>We use information for marketing purposes.</strong>
            We might send you information about special promotions or offers. We
            might also tell you about new features or products. These might be
            our own offers or products, or third-party offers or products we
            think you might find interesting.
        </p>
        <p>
            <strong>
                We use information to send you transactional communications.
            </strong>
            We might send you emails or SMS or messages over WhatsApp
            or similar platforms about your account or a purchase.
        </p>
        <p>
            We use information as otherwise permitted by law.
        </p>
        <p>
            <strong>Sharing of information with third-parties:</strong>
        </p>
        <p>
            No personal data collected by SOFOS is ever sold to third parties
            except as required by law or under legal obligation:
        </p>
        <p>
            <strong>
                We may share information if we think we have to in order to
                comply with the law or to protect ourselves.
            </strong>
            We will share information to respond to a court order or subpoena.
            We may also share it if a government agency or investigatory body
            requests. Or, we might also share information when we are
            investigating potential fraud.
        </p>
        <p>
            <strong>
                We may share information with any successor to all or part of
                our business.
            </strong>
            For example, if part of our business is sold we may give our
            customer list as part of that transaction.
        </p>
        <p>
            <strong>
                We may share your information for reasons not described in this
                policy only with your consent.
            </strong>
        </p>
        <p>
            <strong>Email Opt-Out</strong>
        </p>
        <p>
            <strong>You can opt out of receiving our marketing emails.</strong>
            To stop receiving our promotional emails, please email
            eduracle@gmail.com. It may take reasonable time not more than 90
            days to process your request. Even if you opt out of getting
            marketing messages, we will still be sending you transactional
            messages through email and SMS or messages over WhatsApp
            or similar platforms about your purchases.
        </p>
        <p>
            BEHAVIOURAL ADVERTISING
        </p>
        <p>
            As described above, we use your Personal Information to provide you
            with targeted advertisements or marketing communications we believe
            may be of interest to you.
        </p>
        <p>
            YOUR RIGHTS
        </p>
        <p>
            You have the right to access personal information we hold about you
            and to ask that your personal information be corrected, updated, or
            deleted. Amending Personal Information: You can amend, delete,
            review, receive your personal information by sending an email to
            eduracle@gmail.com. For exercising these right you have to visit
            your profile page under the Accounts section. You can also object to
            the use of your personal information in a specified manner. We note
            that we are processing your information in order to fulfill
            contracts we might have with you (for example if you make an order
            through the website), or otherwise to pursue our legitimate business
            interests listed above.
        </p>
        <p>
            DATA RETENTION
        </p>
        <p>
            The information provided by you shall be retained as long as your
            account is operational and in use. We will delete information based
            on a request received from you within a reasonable period and latest
            within 90 days of receiving a deletion request. When you place an
            order through the webite, we will maintain your Order Information
            for our records unless and until you ask us to delete this
            information or till your services are active.
        </p>
        <p>
            MINORS
        </p>
        <p>
            The content on the website is prepared so that students can use it
            for preparation of competitive exams. Persons who are minors,
            un-discharged insolvents etc. can use our products or services under
            the guidance of legal guardian or parents. As a minor if you wish to
            use our products or services and make payment for such services then
            such use shall be made available to you by your legal guardian or
            parents. Sofos Learning Solutions Private Limited will not be
            responsible for any consequence that arises as a result of misuse of
            any kind of our products or services that may occur by virtue of any
            person including a minor using the services provided. By using the
            products or services you warrant that all the data provided by you
            is accurate and complete and that you have obtained the consent of
            parent/legal guardian (in case of minors).
        </p>
        <p>
            CHANGES
        </p>
        <p>
            We may update this privacy policy from time to time in order to
            reflect, for example, changes to our practices or for other
            operational, legal or regulatory reasons.
        </p>
        <p>
            Jurisdiction:
        </p>
        <p>
            The website, our services and the use of it is governed by the laws
            of India and the courts in Pune shall have exclusive jurisdiction
            over any disputes connected to our website or its policies.
        </p>
        <p>
            CONTACT US
        </p>
        <p>
            For more information about our privacy practices, if you have
            questions, or if you would like to make a complaint, please contact
            us by e-mail at eduracle@gmail.com or by written mail using the
            details provided below:
        </p>
        <p>
            Cabin No. 23, 2nd Floor, West Block, Amanora Mall, Mundhwa–Kharadi
            Road, Amanora Park Town, Pune, Maharashtra – 411028.
        </p>
        <p>
            We will try to resolve your grievance within reasonable time.
        </p>
    </div>
    </v-col>
    </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "Terms-and-condtions",
    mounted() {},
    data() {
        return {};
    },

    methods: {},
};
</script>
